// extracted by mini-css-extract-plugin
export var boldText = "_7d-4";
export var checkboxContainer = "_7d-6";
export var closeIcon = "_7d-i";
export var container = "_7d-0";
export var drawer = "_7d-8";
export var drawerContent = "_7d-9";
export var extraSmallText = "_7d-5";
export var fulfillmentGroupTable = "_7d-e";
export var largeText = "_7d-3";
export var loadingSpinnerContainer = "_7d-j";
export var mediumText = "_7d-2";
export var narrow = "_7d-f";
export var notificationLink = "_7d-l";
export var packageCheckIconContainer = "_7d-7";
export var slideoutHeaderActions = "_7d-g";
export var slideoutHeaderActionsShifted = "_7d-h";
export var slideoutHeaderContainer = "_7d-a";
export var slideoutModal = "_7d-c";
export var stickyHeaderWrapper = "_7d-b";
export var table = "_7d-k";
export var tableContainer = "_7d-d";
export var tertiaryText = "_7d-1";